import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { useLanguage } from "@/hooks/useLanguage";

interface FAQSectionI18nProps {
  translationPrefix: string;
  bgClass?: string;
  itemClass?: string;
}

const FAQSectionI18n = ({ translationPrefix, bgClass = "bg-background", itemClass = "border-border" }: FAQSectionI18nProps) => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const items = tObject<Array<{ question: string; answer: string }>>(`${translationPrefix}.faq.items`);

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className={cn("py-16 md:py-24 transition-all duration-700 ease-out", bgClass, isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t(`${translationPrefix}.faq.badge`)}</Badge>
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground">{t(`${translationPrefix}.faq.title`)}</h2>
          </div>
          <Accordion type="single" collapsible className={itemClass.includes("rounded") ? "space-y-4" : "w-full"}>
            {items.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`} className={cn(itemClass, "transition-all", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")} style={{ transitionDelay: isVisible ? `${index * 50}ms` : "0ms", transitionDuration: "400ms" }}>
                <AccordionTrigger className="text-left text-lg font-medium text-foreground hover:text-primary hover:no-underline py-6">{item.question}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6">{item.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSectionI18n;
